import { useAuthStore } from '~~/stores/AuthStore';
export default function useCheckRequestStatusCode() {
  function checkStatusCode(statusCode) {
    const authStore = useAuthStore();
    const { removeValue } = useLocalStorage();

    if (statusCode === 401) {
      removeValue('token');
      delete authStore.auth.headers.Authorization;
      authStore.auth.token = '';
      authStore.auth.user = {};
      navigateTo({ path: '/auth/signin' });
      window.location.reload();
    }
  }
  return { checkStatusCode };
}
